module.exports = __webpack_public_path__ + "img/22.7e54f689.jpg";